import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, Menu, Grid } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import { Filter, Main } from 'Containers/';
import { DailyDepositTable } from './components/DailyDepositTable';
import {
  getData,
  deleteDailyDeposit,
  clearDeleted,
  setFilterField,
} from './state/modifydailydepositgrid/actions';
import * as types from './state/modifydailydepositgrid/types';
import { LoadingPage, YesNoDialog } from 'Components/';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { LabeledInput } from 'Common/SemanticWrapper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { createToast, toastType } from 'Common/ToastHelper';
import { SiteComponent } from 'Common/SiteComponent';
import { DATE_FORMAT_FOR_DB_STRING } from 'Common/Constants';
import { getControlInfo } from 'State/controlInfo/actions';
import { fiscalYear, actualDT, getFetching } from 'State/selectors';
import { closeSchoolYearClosedDate } from './helpers/EditDailyDepositHelpers';

class ModifyDailyDepositsContainer extends Component {
  state = {
    showDeleteModal: false,
    deleteId: null,
    deleteDailyDepositId: null,
    deleteSiteId: null,
    deleteIsModified: null,
    deleteIsNew: null,
    deleteDate: null,
    closeSchoolYearClosedDate: null,
    showPreviousFiscalYearLabel: false,
  };

  reactTable = React.createRef();

  componentDidMount() {
    const {
      fiscalYear,
      controlInfoActualDT,
      getControlInfo,
      getData,
    } = this.props;

    if (!fiscalYear || !controlInfoActualDT) {
      getControlInfo();
    }

    if (this.validateFields()) {
      getData(this.props);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      isSupper,
      fromDate,
      toDate,
      site,
      deleted,
      getData,
      clearDeleted,
      tableLoading,
    } = this.props;

    if (deleted && deleted !== prevProps.deleted) {
      createToast(
        toastType.success,
        'Success',
        'Daily Deposit deleted successfully.'
      );
      clearDeleted();
    }

    if (prevProps.tableLoading !== tableLoading && tableLoading === false) {
      this.setShowPreviousFiscalYearLabel(1);
    }

    if (
      this.validateFields() &&
      prevProps &&
      (prevProps.isSupper !== isSupper ||
        prevProps.site !== site ||
        prevProps.toDate !== toDate ||
        prevProps.fromDate !== fromDate)
    ) {
      getData(this.props);
    }
  }

  validateFields = () => {
    const { site, fromDate, toDate } = this.props;
    return (
      site &&
      fromDate &&
      toDate &&
      moment(fromDate).isSameOrBefore(toDate) &&
      moment(toDate, DATE_FORMAT_FOR_UI, true).isValid() &&
      moment(fromDate, DATE_FORMAT_FOR_UI, true).isValid()
    );
  };

  siteChange = site => {
    this.props.setFilterField(types.MODIFY_DAILY_DEPOSIT_SET_SITE, site);
  };

  cogOptions = [
    {
      icon: 'pencil',
      text: 'Edit',
      handler: row => {
        this.props.history.push(
          `/modifydailydeposits/${row.SiteId}/${moment(row.ClosingDate).format(
            DATE_FORMAT_FOR_DB_STRING
          )}/${this.props.isSupper ? 1 : 0}`
        );
      },
      disabledWhen: row => row.isEditDisabled,
    },
    {
      icon: 'trash',
      text: 'Delete',
      handler: row => {
        this.setState({
          showDeleteModal: true,
          deleteId: row.Id,
          deleteDailyDepositId: row.Id,
          deleteSiteId: row.SiteId,
          deleteIsModified: row.IsModified,
          deleteIsNew: row.IsNew,
          deleteDate: defaultDateFormat(row.ClosingDate),
        });
      },
      disabledWhen: row => row.IsNew !== 1 || row.isEditDisabled,
    },
    {
      icon: 'trash',
      text: 'Clear Changes',
      handler: row => {
        this.setState({
          showDeleteModal: true,
          deleteId: row.Id,
          deleteDailyDepositId: row.Id,
          deleteSiteId: row.SiteId,
          deleteIsModified: row.IsModified,
          deleteIsNew: row.IsNew,
          deleteDate: defaultDateFormat(row.ClosingDate),
        });
      },
      disabledWhen: row =>
        row.IsModified !== 1 || row.IsNew === 1 || row.isEditDisabled,
    },
  ];

  MealTypeOptions = [
    {
      label: 'Breakfast/Lunch/Other',
      value: false,
    },
    {
      label: 'Supper',
      value: true,
    },
  ];

  handlePageChange = pageIndex => {
    this.setShowPreviousFiscalYearLabel(pageIndex + 1);
  };

  handleSortedChange = () => {
    if (this.reactTable.current) {
      this.setShowPreviousFiscalYearLabel(
        this.reactTable.current.state.page + 1
      );
    }
  };

  setShowPreviousFiscalYearLabel = page => {
    if (this.reactTable.current) {
      const currentResolvedState = this.reactTable.current.getResolvedState();
      const data = currentResolvedState.sortedData;
      const pageSize = currentResolvedState.pageSize;

      const firstIndex = (page - 1) * pageSize;
      const endingIndex = page * pageSize;

      const currentPageData = data.slice(firstIndex, endingIndex);

      let showPreviousFiscalYearLabel = false;
      showPreviousFiscalYearLabel = currentPageData.some(x => {
        if (x._original.isEditDisabled) {
          return true;
        } else {
          return false;
        }
      });

      this.setState({ showPreviousFiscalYearLabel });
    }
  };

  render() {
    const {
      isSupper,
      fromDate,
      toDate,
      data,
      pageLoading,
      tableLoading,
      fiscalYear,
      controlInfoActualDT,
      controlInfoFetching,
    } = this.props;

    const { showPreviousFiscalYearLabel } = this.state;

    let closedDate = null;
    if (!controlInfoFetching) {
      closedDate = closeSchoolYearClosedDate(fiscalYear, controlInfoActualDT);
    }

    return (
      <Fragment>
        {pageLoading ? <LoadingPage /> : undefined}
        <Filter title={'Modify Daily Deposits'}>
          <Menu secondary>
            <Menu.Menu position="right">
              <Menu.Item>
                <Button
                  content={`Add New ${isSupper ? 'Supper ' : ''}Daily Deposit`}
                  onClick={() => {
                    this.props.history.push(
                      `/modifydailydeposits/0/0/${isSupper ? 1 : 0}`
                    );
                  }}
                />
              </Menu.Item>
            </Menu.Menu>
          </Menu>
        </Filter>
        <Main>
          <Grid>
            <Grid.Row>
              <Grid.Column width={3}>
                <LabeledInput
                  label={'From Date'}
                  error={
                    moment(fromDate).isAfter(toDate)
                      ? 'From date must be before to date.'
                      : ''
                  }
                >
                  <DatePicker
                    onChange={date =>
                      this.props.setFilterField(
                        types.MODIFY_DAILY_DEPOSIT_SET_FROM_DATE,
                        defaultDateFormat(date)
                      )
                    }
                    selected={(fromDate ? moment(fromDate) : moment()).toDate()}
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                  />
                </LabeledInput>
              </Grid.Column>
              <Grid.Column width={3}>
                <LabeledInput
                  label={'To Date'}
                  error={
                    moment(fromDate).isAfter(toDate)
                      ? 'To date must be after from date.'
                      : ''
                  }
                >
                  <DatePicker
                    onChange={date =>
                      this.props.setFilterField(
                        types.MODIFY_DAILY_DEPOSIT_SET_TO_DATE,
                        defaultDateFormat(date)
                      )
                    }
                    selected={(toDate ? moment(toDate) : moment()).toDate()}
                    showMonthDropdown
                    showYearDropdown
                    scrollableYearDropdown
                  />
                </LabeledInput>
              </Grid.Column>
              <Grid.Column width={5}>
                <SiteComponent
                  onChange={this.siteChange}
                  value={this.props.site}
                  isAllRequired={true}
                  selectFirst={true}
                />
              </Grid.Column>
              <Grid.Column width={5}>
                <LabeledInput label={'Meal Type'} skipInput>
                  <Button.Group basic className={`btn-group--active-group`}>
                    {this.MealTypeOptions.map((option, i) => {
                      return (
                        <Button
                          basic
                          active={isSupper === option.value}
                          className="white"
                          key={i}
                          onClick={e =>
                            this.props.setFilterField(
                              types.MODIFY_DAILY_DEPOSIT_SET_ISSUPPER,
                              option.value
                            )
                          }
                        >
                          {option.label}
                        </Button>
                      );
                    })}
                  </Button.Group>
                </LabeledInput>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                {showPreviousFiscalYearLabel
                  ? '* Indicates the Daily Deposit is from a previous fiscal year and cannot be edited.'
                  : ''}
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <DailyDepositTable
            loading={tableLoading || controlInfoFetching}
            data={data && closedDate ? data : []}
            reactTableRef={this.reactTable}
            cogOptions={this.cogOptions}
            closeSchoolYearClosedDate={closedDate ? closedDate : moment()}
            handleSortedChange={this.handleSortedChange}
            handlePageChange={this.handlePageChange}
          />
        </Main>
        <YesNoDialog
          title={`${
            this.state.deleteIsNew === 1
              ? 'Delete Added'
              : this.state.deleteIsModified === 1
              ? 'Clear Modified'
              : ''
          } Daily Deposit?`}
          question={`Are you sure you want to ${
            this.state.deleteIsNew === 1
              ? 'delete the Added'
              : this.state.deleteIsModified === 1
              ? 'clear changes for the Modified'
              : ''
          } Daily Deposit for Serving Site ${this.state.deleteSiteId} on ${
            this.state.deleteDate
          }?`}
          showDialog={this.state.showDeleteModal}
          yesCallback={() => {
            this.props.deleteDailyDeposit(
              this.state.deleteDailyDepositId,
              this.state.deleteSiteId,
              fromDate,
              toDate,
              isSupper
            );
            this.setState({
              showDeleteModal: false,
              deleteId: null,
              deleteDailyDepositId: null,
              deleteSiteId: null,
              deleteIsModified: null,
              deleteIsNew: null,
              deleteDate: null,
            });
          }}
          noCallback={() => {
            this.setState({
              showDeleteModal: false,
              deleteId: null,
              deleteDailyDepositId: null,
              deleteSiteId: null,
              deleteIsModified: null,
              deleteIsNew: null,
              deleteDate: null,
            });
          }}
        />
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  const { ModifyDailyDepositGrid } = state.ModifyDailyDepositState;
  return {
    pageLoading: ModifyDailyDepositGrid.pageLoading,
    tableLoading: ModifyDailyDepositGrid.tableLoading,
    siteOptions: ModifyDailyDepositGrid.siteOptions,
    data: ModifyDailyDepositGrid.data,
    fromDate: ModifyDailyDepositGrid.fromDate,
    toDate: ModifyDailyDepositGrid.toDate,
    site: ModifyDailyDepositGrid.site,
    isSupper: ModifyDailyDepositGrid.isSupper,
    fiscalYear: fiscalYear(state),
    controlInfoActualDT: actualDT(state),
    controlInfoFetching: getFetching(state),
  };
};

export const ModifyDailyDeposits = withRouter(
  connect(mapStateToProps, {
    getData,
    getControlInfo,
    deleteDailyDeposit,
    clearDeleted,
    setFilterField,
  })(ModifyDailyDepositsContainer)
);



// WEBPACK FOOTER //
// ./src/pages/modifydailydeposits/ModifyDailyDeposits.js